function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_636",
  "data-name": "Group 636",
  transform: "translate(-10.4 -7.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_651",
  "data-name": "Path 651",
  d: "M39.324,32.155,37.282,15.782a1.079,1.079,0,0,0-1.134-.908H31.156V12.756a5.294,5.294,0,0,0-10.588,0v2.118H15.576a1.079,1.079,0,0,0-1.134.908L12.4,32.193v.113a5.213,5.213,0,0,0,5.256,5.218H34.144A5.245,5.245,0,0,0,39.4,32.269C39.362,32.269,39.362,32.231,39.324,32.155Zm-16.487-19.4a3.025,3.025,0,0,1,6.05,0v2.118h-6.05ZM34.106,35.294H17.618a2.915,2.915,0,0,1-2.987-2.836L16.56,17.143h4.008v2.609a2.926,2.926,0,0,0-1.55,2.42,2.647,2.647,0,0,0,5.294,0,2.836,2.836,0,0,0-1.475-2.345V17.181h6.05V19.79A2.361,2.361,0,0,0,27.3,22.21a2.647,2.647,0,0,0,5.294,0,2.8,2.8,0,0,0-1.437-2.345V17.218h4.008l1.929,15.315A2.9,2.9,0,0,1,34.106,35.294ZM22.459,22.172a.756.756,0,1,1-.756-.756A.759.759,0,0,1,22.459,22.172Zm8.244,0a.756.756,0,1,1-.756-.756A.759.759,0,0,1,30.7,22.172Z",
  transform: "translate(-2 0)",
  fill: "#d71635"
}));

var SvgIconShop = function SvgIconShop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30.025,
    viewBox: "0 0 27 30.025",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconShop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconShop.ffae396d.svg";
export { ForwardRef as ReactComponent };